module.exports = __webpack_public_path__ + "static/media/project1.1d4fa3ef.png";